const SingleLineSkeletonLoader = ({
  width = "100%",
  height = "16px",
  className = "",
  count = 1,
  spacing = "8px",
}) => {
  return (
    <div className={`skeleton-container ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="skeleton-line"
          style={{
            width,
            height,
            marginBottom: index < count - 1 ? spacing : "0",
          }}
        >
          <div className="skeleton-shimmer" />
        </div>
      ))}
    </div>
  );
};

export default SingleLineSkeletonLoader;
